import React from 'react';
import styled from 'styled-components';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

interface BlockBuilderBirdeyeReviewWidgetProps {
  value: {
    _key: string;
    heading: string;
    widgetCode: string;
  };
}

const Container = styled.div`
  min-height: 250px;

  h2 {
    text-align: center;
  }
`;

const IframeResizer = React.lazy(() => import('iframe-resizer-react'));

function BlockBuilderBirdeyeReviewWidget({
  value,
}: BlockBuilderBirdeyeReviewWidgetProps) {
  const { tt } = useUiComponentsInternationalContext();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _key, heading, widgetCode } = value;

  // Regular expression to match the widgetId and widgetType
  const regex = /\/embed\/v7\/(\d+)\/(\d+)\//;
  const match = widgetCode?.match(regex);
  const widgetId = match?.[1];
  const widgetType = match?.[2];

  return (
    <Container>
      {heading && <h2>{heading}</h2>}
      <IframeResizer
        id={`${_key}-review-widget`}
        title={tt(
          s => s.blockBuilderBirdeyeReviewWidgetComponent.customerReviewsHeader
        )}
        style={{
          borderWidth: 0,
          width: 'auto',
          minWidth: 150,
          minHeight: 280,
          display: 'block',
          overflow: 'auto',
          margin: '0 auto',
        }}
        src={`https://widgets-v7.birdeye.com/api/widgets?bid=${widgetId}&wno=${widgetType}`}
        allow="payment"
      />
    </Container>
  );
}

export default BlockBuilderBirdeyeReviewWidget;
